import { useState, useEffect, useCallback } from 'react'
import { inject, observer } from 'mobx-react'
import { useLocation } from 'react-router-dom'
import { PageView, Title, Desc, TabWrapper, TabItem } from './index.styled'
import { Box, Grid } from '@chakra-ui/react'
import queryString from 'query-string'

import MobileLogin from './MobileLogin'
import EmailLogin from './EmailLogin'

const OtpLogin = (props) => {
  const location = useLocation()
  const [loginType, setLoginType] = useState('mobile')

  const { language } = props
  const { lang, type } = queryString.parse(location.search)

  const onInit = useCallback(() => {
    props.language.setLanguage(lang)
  }, [lang, props.language])

  useEffect(() => {
    onInit()
  }, [onInit])

  useEffect(() => {
    if (type) {
      setLoginType(type)
    }
  }, [type])

  return (
    <PageView>
      <Title>
        {language.getMsg('Verify your account', 'ยืนยันบัญชีของคุณ')}
      </Title>
      <Desc>
        {language.getMsg(
          'Please enter your mobile number or email to request OTP.',
          'กรอกหมายเลขโทรศัพท์หรืออีเมลของคุณเพื่อยืนยันบัญชี'
        )}
      </Desc>

      <Box position="relative">
        <TabWrapper>
          <Grid Grid templateColumns="repeat(2, 1fr)">
            <TabItem
              className={`${loginType === 'mobile' ? 'active' : ''}`}
              onClick={() => setLoginType('mobile')}
            >
              {language.getMsg('Mobile number', 'เบอร์มือถือ')}
            </TabItem>
            <TabItem
              className={`${loginType === 'email' ? 'active' : ''}`}
              onClick={() => setLoginType('email')}
            >
              {language.getMsg('Email', 'อีเมล')}
            </TabItem>
          </Grid>
        </TabWrapper>
        {loginType === 'email' ? <EmailLogin /> : <MobileLogin />}
      </Box>
    </PageView>
  )
}

export default inject('otp', 'language')(observer(OtpLogin))
